const PatHealthStatsState = {
  data: {}
}

export default PatHealthStatsState
